import { CarbonIconType } from "@carbon/icons-react";
import { createElement } from "react";

export const Icon = ({ icon }: { icon: CarbonIconType }): JSX.Element => {
  return <>{createElement(icon)}</>;
};
